/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
// import { isEmpty } from 'lodash';
import styled, { css } from 'styled-components';
// import { formatMoneyNumeral } from '../../util/helpers/numeralHelpers';
import NumberField from './NumberField';
// import { CashOrderOnly } from '../CashOrderOnly/CashOrderOnly';
// import CurrencyField from './CurrencyField';
import { uFlexColumn } from '../../assets/styles/utility';
import { mediaBelow, pxToRem, pxToRemMd } from '../../assets/styles/helper';
import themeColors from '../../assets/styles/themeColors';
import { variables } from '../../assets/styles/variables';
// import CurrencyInputField from './CurrencyInputField';
import { ReactComponent as PlusIcon } from '../../assets/images/svg/quantity-plus.svg';
import { ReactComponent as MinusIcon } from '../../assets/images/svg/quantity-minus.svg';
import { ReactComponent as Switch } from '../../assets/images/svg/switch.svg';
import { ReactComponent as HandCoins } from '../../assets/images/svg/hand-coins.svg';
import Paragraph from '../Paragraph/Paragraph';
import { formatMoneyNumeral } from '../../util/helpers/numeralHelpers';

const getActiveTypeStyles = (activeType) => {
  if (activeType === 'Cash') {
    return `
      > :first-child {
          background-color: ${themeColors.colorButtonPrimary};
          color: ${themeColors.colorWhite} !important;
      }
    `;
  }

  if (activeType === 'Quantity') {
    return `
      > :last-child {
          background-color: ${themeColors.colorButtonPrimary};
          color: ${themeColors.colorWhite} !important;
      }
    `;
  }
};

export const BuyFieldsContainer = styled.div`
  ${uFlexColumn};
  align-items: center;
  width: 100%;
`;

export const BuyFieldsButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0 0 ${pxToRem(24)};

  > button {
    border: 1px solid ${themeColors.colorButtonPrimary};
    color: ${themeColors.colorButtonPrimary};
    font-size: ${pxToRem(16)};
    line-height: 1.5;
  }

  > :first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 0;
  }

  > :last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  ${({ activeType }) => getActiveTypeStyles(activeType)};

  ${mediaBelow(variables.breakpoints.bpMd)} {
    margin: 0 0 ${pxToRemMd(24)};
  }
`;

export const buyFieldsSelectedButton = css`
  background-color: ${themeColors.colorPrimary};
  color: ${themeColors.colorWhite} !important;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 20px 0;
  position: relative;

  input {
    text-align: center;
    font-family: ${({ isGS }) => isGS && variables.family.goldSilverHeaders};
    font-size: ${pxToRem(42)};
    font-weight: 600;
    padding: 10px;
    border: 0;
    border-radius: 8px;
    color: ${themeColors.colorTextPrimary};
    transition: width 0.2s ease;
    field-sizing: content;

    ::placeholder {
      color: ${themeColors.colorTextPrimary};
      opacity: 1;
    }
  }

  button {
    width: ${pxToRem(44)};
    height: ${pxToRem(44)};
    border-radius: ${variables.borderRadius.borderRadius};
    border: 1px solid ${themeColors.colorCardBorder};
    background: ${themeColors.colorBackgroundSecondary};
    cursor: pointer;
    transition: background 0.2s;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      background: #eee;
    }
  }

  ${mediaBelow(variables.breakpoints.bpMd)} {
    input {
      font-size: ${pxToRemMd(36)};
    }
    button {
      width: ${pxToRemMd(36)};
      height: ${pxToRemMd(36)};
      svg {
        width: ${pxToRemMd(22)};
        height: ${pxToRemMd(22)};
      }
    }
  }
`;

const InputContent = styled.div`
  position: relative;
`;

const DollarSign = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  font-family: ${({ isGS }) => isGS && variables.family.goldSilverHeaders};
  font-size: ${pxToRem(18)};
  font-weight: 400;
  color: ${themeColors.colorTextPrimary};
  opacity: 0.5;

  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-size: ${pxToRemMd(16)};
  }
`;

const ToggleButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  p {
    font-size: ${pxToRem(14)};
  }

  svg {
    margin-right: 2px;
  }

  ${mediaBelow(variables.breakpoints.bpMd)} {
    p {
      font-size: ${pxToRemMd(12)};
    }
    svg {
      width: ${pxToRemMd(14)};
    }
  }
`;

const CalculatedValues = styled(Paragraph)`
  font-size: ${pxToRem(16)};
  text-align: center;
  margin: 0 auto;
  color: ${themeColors.colorTextPrimary};
  padding: 0 ${pxToRem(20)};
  border-bottom: ${({ isPostPaid }) =>
    !isPostPaid && `0.5px solid ${themeColors.colorBorderPrimary}`};

  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-size: ${pxToRemMd(14)};
    margin: 0 auto;
  }
`;

const SavingInfo = styled(Paragraph)`
  font-size: ${pxToRem(14)};
  color: ${themeColors.colorSuccess};
  margin-top: ${pxToRem(9)};

  svg {
    display: inline-block;
    vertical-align: middle;
    margin-right: ${pxToRem(4)};
  }

  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-size: ${pxToRemMd(12)};
    margin-top: ${pxToRemMd(8)};
  }
`;

const CalculatedValuesWrapper = styled.div`
  background-color: ${themeColors.colorPrimaryLight};
  border: 1px solid ${themeColors.colorCardBorder};
  padding: ${pxToRem(10)};
  max-width: ${pxToRem(402)};
  width: 100%;
  margin-top: ${pxToRem(26)};
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mediaBelow(variables.breakpoints.bpMd)} {
    max-width: ${pxToRemMd(274)};
    margin-top: ${pxToRemMd(18)};
  }
`;

const BalanceInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BalanceInfoTitle = styled.p`
  font-size: ${pxToRem(14)};
  font-weight: 400;
  color: ${themeColors.colorTextSecondary};

  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-size: ${pxToRem(12)};
  }
`;

const BalanceInfoValue = styled.p`
  font-size: ${pxToRem(14)};
  font-weight: 600;
  color: ${themeColors.colorTextSecondary};

  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-size: ${pxToRem(12)};
  }
`;

const BuyInputFields = ({
  activeType,
  setActiveType,
  values,
  setFieldValue,
  // selectedVault,
  unitPrice,
  priceCCPerUnit,
  setFieldTouched,
  // setDeliveryFees,
  // deliveryFees,
  // setLimitation,
  // displayError,
  // setGetQuotesError,
  setPricePerUnit,
  setPriceCCPerUnit,
  // onValuesChange,
  selectedPaymentMethod,
  setSavingAmount,
  productTiers,
  setOrderValues,
  isGS,
  isPostPaidVisible,
  availableForTrading,
  // setPriceCCPerUnit,
}) => {
  const { t } = useTranslation();

  const isSelectedCreditCardPaymentMethod =
    selectedPaymentMethod?.PaymentMethodType === 3;

  // const { IsCashOrderOnly } = selectedVault;

  // const account = useSelector(getCurrentAccount);
  // const productTiers = useSelector(selectProductTiers);

  // const dispatch = useDispatch();
  // const [activeType, setactiveType] = useState('quantity'); // "quantity" | "dollars"
  // const [value, setValue] = useState('');

  const priceBasedOnPaymentMethod = isSelectedCreditCardPaymentMethod
    ? priceCCPerUnit
    : unitPrice;

  // useEffect(() => {
  //   if (onValuesChange) {
  //     onValuesChange(values);
  //   }
  // }, [values, onValuesChange]);

  // useEffect(() => {
  //   if (locationForTiers) {
  //     dispatch(
  //       fetchProductTiers({
  //         accountUid: account.AccountUid,
  //         symbol,
  //         side: 'Buy',
  //         location: locationForTiers,
  //         trueTiers: true,
  //       }),
  //     );
  //   }
  // }, [account.AccountUid, dispatch, locationForTiers, symbol]);

  const [debouncedAmount, setDebouncedAmount] = useState(0);
  const amount =
    activeType === 'dollars' ? values.CashAmount : values.QuantityAmount;

  useEffect(() => {
    if (!amount || amount === '0' || amount === 0) {
      setDebouncedAmount(0);
      return;
    }

    const handler = setTimeout(() => {
      setDebouncedAmount(amount);
    }, 200);

    return () => clearTimeout(handler);
  }, [amount, activeType]);

  useEffect(() => {
    if (!productTiers?.Tiers?.length || !debouncedAmount) return;

    const effectiveAmount =
      activeType === 'quantity'
        ? debouncedAmount * priceBasedOnPaymentMethod
        : debouncedAmount;

    const matchedTier = productTiers.Tiers.find((tier) => {
      if (!tier.HighBound && tier.LowBound <= effectiveAmount) return true;
      if (tier.HighBound >= effectiveAmount && tier.LowBound <= effectiveAmount)
        return true;
      return false;
    });

    if (!matchedTier) return;

    if (isSelectedCreditCardPaymentMethod) {
      setPriceCCPerUnit((prev) => {
        const newValue = matchedTier.BuyCCPricePerUnit;
        return prev !== newValue ? newValue : prev;
      });
    } else {
      setPricePerUnit((prev) => {
        const newValue = matchedTier.PricePerUnit;
        return prev !== newValue ? newValue : prev;
      });
    }
  }, [
    JSON.stringify(productTiers?.Tiers),
    debouncedAmount,
    activeType,
    priceBasedOnPaymentMethod,
    isSelectedCreditCardPaymentMethod,
  ]);

  const handleIncrease = () => {
    if (activeType === 'quantity') {
      const next = (Number(values.QuantityAmount) || 0) + 1;
      setFieldTouched('QuantityAmount');
      setFieldValue('QuantityAmount', next);
      setOrderValues((prev) => ({
        ...prev,
        QuantityAmount: next,
      }));
    }
  };

  const handleDecrease = () => {
    if (activeType === 'quantity') {
      const next = (Number(values.QuantityAmount) || 0) - 1;
      setFieldTouched('QuantityAmount');
      setFieldValue('QuantityAmount', next > 0 ? next : '');
      setOrderValues((prev) => ({
        ...prev,
        QuantityAmount: next > 0 ? next : '',
      }));
    }
  };

  const handleKeyDown = (event) => {
    const invalidKeys = ['e', 'E', '+', '-'];
    if (invalidKeys.includes(event.key)) {
      event.preventDefault();
    }
  };

  // const handleInputChange = (e) => {
  //   const sanitizedValue = e.target.value;
  //   // .replace(/[^0-9]/g, '')
  //   // .replace(/^0+/, '')
  //   // .replace(/e/g, '');
  //   if (activeType === 'quantity') {
  //     setFieldTouched('QuantityAmount');
  //     setFieldValue('QuantityAmount', sanitizedValue);
  //     setOrderValues((prev) => ({
  //       ...prev,
  //       QuantityAmount: sanitizedValue || '',
  //     }));
  //   } else {
  //     setFieldTouched('CashAmount', true, false);
  //     setFieldValue('CashAmount', sanitizedValue || '', false);
  //     setOrderValues((prev) => ({
  //       ...prev,
  //       CashAmount: sanitizedValue || '',
  //     }));
  //   }
  // };

  const toggleactiveType = () => {
    // setValue('');
    setActiveType((prev) => {
      const next = prev === 'quantity' ? 'dollars' : 'quantity';
      setOrderValues((prevVals) => ({
        ...prevVals,
        activeType: next,
      }));
      return next;
    });
  };

  const quantity =
    activeType === 'quantity'
      ? Number(values.QuantityAmount || 0)
      : Math.floor(
          (Number(values.CashAmount) || 0) / priceBasedOnPaymentMethod,
        );

  const totalPrice = quantity * unitPrice;
  const totalCCPrice = quantity * priceCCPerUnit;
  const priceCashCardDifference = totalCCPrice - totalPrice;
  const totalPriceBasedOnPaymentMethod =
    selectedPaymentMethod?.PaymentMethodType === 3 ? totalCCPrice : totalPrice;

  useEffect(() => {
    if (!priceCashCardDifference) {
      setSavingAmount(0);
    }
    if (priceCashCardDifference) {
      setSavingAmount(priceCashCardDifference);
    }
  }, [priceCashCardDifference]);

  return (
    <BuyFieldsContainer>
      <div>
        {activeType === 'dollars' && (
          // activeType === 'Cash'
          <InputWrapper>
            <InputContent>
              <DollarSign isGS={isGS}>$</DollarSign>
              <Field name="CashAmount">
                {({ field, form }) => (
                  <NumberField
                    placeholder={0}
                    name="CashAmount"
                    component={NumberField}
                    centerText
                    autoFocus
                    field={field}
                    form={form}
                    isGS={isGS}
                    hideError
                    autoComplete="off"
                    onChange={(e) => {
                      const { value } = e.target;
                      setFieldValue('CashAmount', value);
                      setFieldTouched('CashAmount', true);

                      // setOrderValues((prev) => ({
                      //   ...prev,
                      //   QuantityAmount: value,
                      // }));
                    }}
                    onKeyDown={handleKeyDown}
                    // disabled={IsCashOrderOnly}
                    value={values.CashAmount || ''}
                    data-cy="input-quantity"
                  />
                )}
              </Field>
            </InputContent>
          </InputWrapper>
        )}
        {activeType === 'quantity' && (
          // activeType === 'Quantity'
          <>
            <InputWrapper>
              <button
                type="button"
                isGS={isGS}
                // onClick={() => {
                // const newValue = Math.max(
                //   0,
                //   (values.QuantityAmount || 0) - 1,
                // );
                // setFieldTouched('QuantityAmount');
                // setFieldValue('QuantityAmount', newValue);
                // if (setLimitation) setLimitation(unitPrice * newValue);
                // if (setGetQuotesError) setGetQuotesError('');
                // }}
                onClick={handleDecrease}
                disabled={
                  !values.QuantityAmount || Number(values.QuantityAmount) === 0
                }
              >
                <MinusIcon width={26} />
              </button>

              <Field name="QuantityAmount">
                {({ field, form }) => (
                  <NumberField
                    placeholder={0}
                    name="QuantityAmount"
                    component={NumberField}
                    centerText
                    autoFocus
                    field={field}
                    form={form}
                    hideError
                    preventAllExceptNumbers
                    onChange={(e) => {
                      const { value } = e.target;
                      setFieldValue('QuantityAmount', value);
                      setFieldTouched('QuantityAmount', true);

                      // setOrderValues((prev) => ({
                      //   ...prev,
                      //   QuantityAmount: value,
                      // }));
                    }}
                    onKeyDown={handleKeyDown}
                    value={values.QuantityAmount || ''}
                    // disabled={IsCashOrderOnly}
                    data-cy="input-quantity"
                  />
                )}
              </Field>

              <button
                type="button"
                isGS={isGS}
                // onClick={() => {
                // const newValue = (values.QuantityAmount || 0) + 1;
                // setFieldTouched('QuantityAmount');
                // setFieldValue('QuantityAmount', newValue);
                // if (setLimitation) setLimitation(unitPrice * newValue);
                // if (setGetQuotesError) setGetQuotesError('');
                // }}
                onClick={handleIncrease}
              >
                <PlusIcon width={26} />
              </button>
            </InputWrapper>
          </>
        )}
        {/* Toggle Button */}
        <ToggleButton onClick={toggleactiveType}>
          <Switch />
          <Paragraph>
            Switch to {activeType === 'quantity' ? 'Dollar' : 'Quantity'}
          </Paragraph>
        </ToggleButton>

        {/* {displayError && displayError()} */}
        {/* {activeType === 'Quantity' && IsCashOrderOnly && <CashOrderOnly />} */}
      </div>

      {isPostPaidVisible &&
        (quantity > 0 || totalPriceBasedOnPaymentMethod > 0) && (
          <CalculatedValuesWrapper>
            {activeType === 'quantity' && (
              <CalculatedValues isPostPaid={isPostPaidVisible}>
                {quantity} Units ={' '}
                <b>{formatMoneyNumeral(totalPriceBasedOnPaymentMethod)}</b>
              </CalculatedValues>
            )}

            {activeType === 'dollars' && (
              <CalculatedValues isPostPaid={isPostPaidVisible}>
                {formatMoneyNumeral(totalPriceBasedOnPaymentMethod)} ={' '}
                <b>{quantity} Units</b>
              </CalculatedValues>
            )}
            {selectedPaymentMethod?.PaymentMethodType !== 3 && (
              <SavingInfo>
                <HandCoins />
                {t('buyWizard.savingInfo1')}
                <b>{priceCashCardDifference.toFixed(2)}</b>
                {t('buyWizard.savingInfo2')}
              </SavingInfo>
            )}
          </CalculatedValuesWrapper>
        )}
      {!isPostPaidVisible && (
        <CalculatedValuesWrapper>
          {(quantity > 0 || totalPriceBasedOnPaymentMethod > 0) && (
            <>
              {activeType === 'quantity' && (
                <CalculatedValues isPostPaid={isPostPaidVisible}>
                  {quantity} Units ={' '}
                  <b>{formatMoneyNumeral(totalPriceBasedOnPaymentMethod)}</b>
                </CalculatedValues>
              )}

              {activeType === 'dollars' && (
                <CalculatedValues isPostPaid={isPostPaidVisible}>
                  {formatMoneyNumeral(totalPriceBasedOnPaymentMethod)} ={' '}
                  <b>{quantity} Units</b>
                </CalculatedValues>
              )}
            </>
          )}
          <BalanceInfoWrapper>
            <BalanceInfoTitle>
              {t('buyWizard.availableBalance')}
            </BalanceInfoTitle>
            <BalanceInfoValue>
              {formatMoneyNumeral(availableForTrading)}
            </BalanceInfoValue>
          </BalanceInfoWrapper>
        </CalculatedValuesWrapper>
      )}
    </BuyFieldsContainer>
  );
};

BuyInputFields.propTypes = {
  values: PropTypes.shape({
    CashAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    QuantityAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  activeType: PropTypes.string,
  setActiveType: PropTypes.func,
  setFieldValue: PropTypes.func,
  selectedVault: PropTypes.shape({
    // IsCashOrderOnly: PropTypes.bool,
  }),
  setFieldTouched: PropTypes.func,
  // setDeliveryFees: PropTypes.func,
  deliveryFees: PropTypes.shape({}),
  // setLimitation: PropTypes.func,
  unitPrice: PropTypes.number,
  // displayError: PropTypes.func,
  // setGetQuotesError: PropTypes.func,
  setPricePerUnit: PropTypes.func,
  priceCCPerUnit: PropTypes.number,
  setOrderValues: PropTypes.func,
  setPriceCCPerUnit: PropTypes.func,
  selectedPaymentMethod: PropTypes.shape({
    PaymentMethodType: PropTypes.number,
  }),
  setSavingAmount: PropTypes.number,
  productTiers: PropTypes.arrayOf({}),
  isGS: PropTypes.bool,
  isPostPaidVisible: PropTypes.bool,
  availableForTrading: PropTypes.number,
};

export default BuyInputFields;
